import { NumberFormatType } from './types'

export const numberFormats: { [key in NumberFormatType]: Intl.NumberFormatOptions } = {
  significant: {
    style: 'decimal',
    maximumSignificantDigits: 6,
    maximumFractionDigits: 8,
  },
  percentage: {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  percentageInt: {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  toUSD: {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 3,
  },
  toIntUSD: {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  compact: {
    style: 'decimal',
    notation: 'compact',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  compactPercent: {
    style: 'percent',
    notation: 'compact',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
}
